import {
  CHANGE_CURRENCY_STATUS_START,
  CHANGE_CURRENCY_STATUS_SUCCESS,
  CHANGE_CURRENCY_STATUS_ERROR,
  SET_BASE_CURRENCY_START,
  SET_BASE_CURRENCY_SUCCESS,
  SET_BASE_CURRENCY_ERROR,
  SET_PAYOUT_CURRENCY_START,
  SET_PAYOUT_CURRENCY_SUCCESS,
  SET_PAYOUT_CURRENCY_ERROR,
  UPDATE_BASE_CURRENCY
} from '../../../constants';
import {
  getBaseCurrencyQuery, currencyManagementMutation, setBaseCurrencyMutation,
  getAllCurrenciesQuery, updatePayoutCurrencyMutation
} from '../../../lib/graphql';
import showToaster from '../../../helpers/toasterMessages/showToaster'

const updateCurrencyStatus = (id, isEnable, symbol, currentPage, searchList) => {

  return async (dispatch, getState, { client }) => {

    try {
      dispatch({
        type: CHANGE_CURRENCY_STATUS_START,
      });

      let baseCurrencyId;
      const { data } = await client.query({ query: getBaseCurrencyQuery, fetchPolicy: 'network-only' });

      if (data?.getBaseCurrency) {
        baseCurrencyId = data?.getBaseCurrency?.id;
      }

      if (baseCurrencyId === id) {
        showToaster({ messageId: 'disableBaseCurrencyError', toasterType: 'error' })
      } else {

        const { data } = await client.mutate({
          mutation: currencyManagementMutation,
          variables: { id, isEnable, symbol },
          refetchQueries: [{ query: getAllCurrenciesQuery, variables: { currentPage, searchList } }]
        });

        if (data.currencyManagement.status === "success") {
          dispatch({
            type: CHANGE_CURRENCY_STATUS_SUCCESS,
          });
          showToaster({ messageId: 'currencyStatusSuccess', toasterType: 'success' })
        } else if (data.currencyManagement.status === "atLeastOneCurrencyRequired") {
          dispatch({
            type: CHANGE_CURRENCY_STATUS_ERROR,
          });
          showToaster({ messageId: 'updateCurrencyError', toasterType: 'error' })
        } else {
          dispatch({
            type: CHANGE_CURRENCY_STATUS_ERROR,
          });
          showToaster({ messageId: 'failedError', toasterType: 'error', requestMessage: data?.currencyManagement?.errorMessage })
        }
      }

    } catch (error) {

      dispatch({
        type: CHANGE_CURRENCY_STATUS_ERROR,
        payload: {
          error
        }
      });
      showToaster({ messageId: 'currencyStatusFailed', toasterType: 'error' })
      return false;
    }
    return true;
  };
}

const setBaseCurrency = (id, symbol, currentPage, searchList) => {
  return async (dispatch, getState, { client }) => {
    try {
      dispatch({
        type: SET_BASE_CURRENCY_START,
      });

      const { data } = await client.mutate({
        mutation: setBaseCurrencyMutation,
        variables: { id },
        refetchQueries: [{ query: getAllCurrenciesQuery, variables: { currentPage, searchList } }]
      });

      if (data?.baseCurrency?.status === "success") {
        dispatch({
          type: SET_BASE_CURRENCY_SUCCESS,
        });
        dispatch({
          type: UPDATE_BASE_CURRENCY,
          payload: {
            base: symbol
          }
        });
        showToaster({ messageId: 'setDefaultBaseCurrency', toasterType: 'success' })
      }

    } catch (error) {
      dispatch({
        type: SET_BASE_CURRENCY_ERROR,
        payload: {
          error
        }
      });
      showToaster({ messageId: 'setDefaultBaseCurrencyFailed', toasterType: 'error' })
      return false;
    }
    return true;
  };
}


const updatePayoutCurrency = ({ id, symbol, isPayoutCurrency, currentPage, searchList }) => {
  return async (dispatch, getState, { client }) => {
    dispatch({ type: SET_PAYOUT_CURRENCY_START });
    try {
      const { data } = await client.mutate({
        mutation: updatePayoutCurrencyMutation,
        variables: { id, symbol, isPayoutCurrency },
        refetchQueries: [{ query: getAllCurrenciesQuery, variables: { currentPage, searchList } }]
      });

      if (data?.updatePayoutCurrency?.status == 200) {
        dispatch({ type: SET_PAYOUT_CURRENCY_SUCCESS });
        showToaster({ messageId: 'payoutCurrencySuccess', toasterType: 'success' });
      } else if (data?.updatePayoutCurrency?.status !== 200) {
        dispatch({
          type: SET_PAYOUT_CURRENCY_ERROR,
          payload: {
            error: data?.updatePayoutCurrency?.errorMessage
          }
        });
        showToaster({ messageId: 'failedMessage', toasterType: 'error', requestContent: data?.updatePayoutCurrency?.errorMessage })
        return false;
      }
    } catch (error) {
      dispatch({
        type: SET_PAYOUT_CURRENCY_ERROR,
        payload: { error }
      });
      showToaster({ messageId: 'payoutCurrencyFailed', toasterType: 'error' })
      return false;
    }
    return true;
  }
}

export { updateCurrencyStatus, setBaseCurrency, updatePayoutCurrency };